import { render } from "./Contact.vue?vue&type=template&id=407f738a"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=407f738a&lang=scss"
script.render = render

export default script